import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import ApproachPage from "@/pages/Approach";

export const Route = createFileRoute("/$lang/approach")({
  head: ({ params }) => pageHead(params.lang, "approach"),
  component: ApproachPage,
});
